const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};
// Function to return color based on lead status
export const getColor = (status: string): string => {
  switch (status) {
    case "PAID":
      return "#008000";
    case "UNPAID":
      return "#FF9E9E";
    case "PART PAID":
      return "#ffa500";
    case "PENDING":
      return "#F7BD01";
    case "CANCELLED":
      return "#ff0000";
    case "OVERDUE":
      return "#0000ff";

    default:
      return "black";
  }
};

export const getLeadColor = (status: string): string => {
  switch (status) {
    case "NEW LEAD":
    case "NEW":
      return "#FF66C4";
    case "ESTIMATES":
      return "#D16B2C";
    case "SURVEY":
      return "#7ED957";
    case "PENDING":
      return "#FFBB23";
    case "IN PROGRESS":
    case "STARTED":
      return "#3174AD";
    case "COMPLETED":
    case "Completed":
      return "#008e73";
    case "QUOTE":
      return "#FF3131";
    case "CONFIRMED":
      return "#7C3014";
    case "JOB":
      return "#a52a2a";
    case "PROVISIONAL":
      return "#B0C4DE";
    default:
      return "black";
  }
};


export const INVOICE_FILTER_FIELDS = [
  {
    id: "customerId",
    label: "Customer Name",
    placeHolder: "select",
    type: "select",
    options: [],
    md: 2,
   
  },
  {
    id: "customer_email",
    label: "Customer Email ⓘ",
    placeHolder: "Enter Customer Email",
    type: "text",
    md: 2,
    tooltipText:'Invoice statement will be send to this email',
    // isRequired: true,
    // inputProps: {
    //   maxLength: 3,
    // },

  },
  {
    id: "telephone",
    label: "Telephone",
    placeHolder: "Enter Telephone",
    type: "text",
    md: 2,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    disabled: true,
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "startDate",
    label: "Start Date",
    placeHolder: "Enter Start Date",
    type: "date",
    inputProps: {
      marginBottom: '10px',
    },
    md: 2,
  },
  {
    id: "endDate",
    label: "End Date",
    placeHolder: "Enter End Date",
    type: "date",
    inputProps: {
      marginBottom: '10px',
    },
    md: 2,
  },
  {
    id: "invoiceType",
    label: "Invoice Type",
    placeHolder: "select",
    type: "select",
    md: 2,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
  },
  {
    id: "invoiceNumber",
    label: "Invoice Number",
    placeHolder: "Enter Invoice Number",
    type: "text",
    md: 2,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "onlyOutstanding",
    label: "Only Outstanding",
    placeHolder: "Only Outstanding",
    type: "checkbox",
    md: 2,
  },
    {
    id: "onlySynced",
    label: "Only Synced",
    placeHolder: "Only Synced",
    type: "checkbox",
    md: 1,
  },
];